import * as Yup from "yup";

import { translate } from "../../../services/translation.service";

export default Yup.object().shape({
  email: Yup.string()
    .email((): string => translate("authentication.enterValidAddress"))
    .required((): string => translate("authentication.enterValidAddress")),
  password: Yup.string()
    .trim()
    .min(6, () => translate("authentication.enterPasswordCharacters"))
    .required(() => translate("authentication.enterPasswordCharacters")),
});
